<template>
    <div class="container" v-if="hasNoAppointmentId()">
      <h1>Prise de rendez-vous</h1>
      <div class="box">
        <div class="box__inner" style="text-align: center">
          <h2>Aucun rendez-vous trouvé</h2>
          <p><span>Aucun rendez-vous n'existe pour cette carte. <br></span> Vous avez la possibilité de prendre nouveau rendez-vous ici.</p>
          <br>
          <a href="/" class="button button--cancel">
            Prendre rendez-vous
          </a>
        </div>
      </div>
    </div>
    <div class="container" id="validation-carte" v-else-if="!this.isExistingAppointment">
        <h1>Prise de rendez-vous</h1>
        <div class="box">
            <div class="box__inner">
                <h2>Validation de la carte SIVEC</h2>
                <div v-if="!this.numberValidated && this.valid">
                    <label for="card">Numéro de la carte SIVEC</label>
                    <input v-on:keydown="checkSubmission" type="text" v-model="number" id="card" class="card-verification__input">
                    <button v-on:click="validateCard" type="button" class="button button--expanded">Vérifier le numéro</button>
                </div>
                <div v-if="this.numberValidated && this.valid" class="confirmation">
                    <p>{{ number }} <img src="../assets/ui/check.svg" alt=""></p>
                    <div class="button--cancel__container">
                        <button v-on:click="reset" type="button" class="button button--cancel">Annuler</button>
                    </div>
                </div>
                <div v-if="!this.valid" class="invalid">
                    <p class="number">{{ number }} <img src="../assets/ui/cross.svg" alt=""></p>
                    <p v-if="$store.state.errorMessage">{{ $store.state.errorMessage }}</p>
                    <p v-if="!$store.state.errorMessage">{{ t('Erreur d\'application') }}</p>
                    <p>{{ t('Veuillez nous contacter par téléphone') }}: <a href="tel:00352 54 98 98">+352 54 98 98</a></p>
                    <div class="button--cancel__container">
                        <button v-on:click="reset" type="button" class="button button--cancel">Réessayer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" id="validation-carte" v-else>
      <h1>Votre rendez-vous</h1>
      <div class="box">
        <div class="box__inner">
          <template v-if="this.isDeleteScreen">
            <h2 class="box__clock-title">
              <Watch verification />
              Êtes-vous sur de vouloir supprimer ce rendez-vous?
            </h2>
            <p><b>{{ this.$store.state.selectedDate }} {{ t('à') }} {{ this.$store.state.selectedTime }}</b></p>
            <p><b>Nr. de la carte SIVEC</b>: <br> {{ this.$store.state.sivecNumber }}</p>
            <p><b>Numéro de plaque</b>: <br> {{ this.$store.state.plateNumber }}</p>
            <br>
            <div class="actions">
              <button v-on:click="appointmentSummary" type="button" class="button button--ghost">
                <img src="../assets/ui/arrow-back.svg"  alt=""> Retourner
              </button>
              <button v-on:click="deleteAppointment" type="button" class="button button--delete">
                <img src="../assets/ui/bin.svg"  alt="">
                Confirmer la suppression
              </button>
            </div>
          </template>
          <template v-else>
            <h2 class="box__clock-title">
              <Watch verification />
              {{ this.$store.state.selectedDate }} {{ t('à') }} {{ this.$store.state.selectedTime }}
            </h2>
            <p><span>Un rendez-vous existe déjà pour cette carte. <br></span> Vous avez la possibilité de modifier ou de supprimer ce rendez-vous.</p>
            <div class="card-verification__number">{{ number }}</div>
            <label for="card">Code d'identification</label>
            <div class="card-verification__input-tooltip">
              <input type="text" class="card-verification__input" v-model="confirmationToken" id="confirmationToken">
              <Tooltip class="card-verification__input-tooltip__tooltip">
                Vous pouvez  retrouver votre code d'identification dans votre boîte email si vous aviez indiqué votre adresse email lors de la prise de votre rendez-vous.
              </Tooltip>
            </div>
            <p v-if="invalidConfirmationCode" class="invalid-confirmation-code-message">
              <img src="../assets/ui/exclamation--round.svg"  alt=""> Code d'identification invalide!
            </p>
            <div class="actions">
              <button v-on:click="editAppointment" type="button" class="button">
                <img src="../assets/ui/edit.svg"  alt="">
                Modifier
              </button>
              <button v-on:click="deleteAppointment" type="button" class="button button--delete">
                <img src="../assets/ui/bin.svg"  alt="">
                Supprimer
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import Watch from './Watch.vue';
    import Tooltip from './Tooltip.vue';

    const axios = require('axios');
    const VueScrollTo = require('vue-scrollto');
    var cancelScroll;

    export default {
        name: 'CardVerification',
        components: {
            Watch,
            Tooltip
        },
        data: function () {
            return ({
                number: '',
                numberValidated: false,
                valid: true,
                info: null,
                isExistingAppointment: false,
                isDeleteScreen: false,
                isConfirmationCodeChecked: this.$store.state.isConfirmationCodeChecked,
                sivecNumber: null,
                confirmationToken: null,
                invalidConfirmationCode: false
            });
        },
        mounted() {
            // Check for query parameters
            let searchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(searchParams.entries());
            if (('cardNumber' in params && 'confirmationToken' in params) || this.$store.state.sivecNumber){
                let cardNumber = this.$store.state.sivecNumber ? this.$store.state.sivecNumber : params.cardNumber
                let confirmationToken = this.$store.state.confirmationToken ? this.$store.state.confirmationToken : params.confirmationToken
                // Load appointment informations
                axios
                    .get(`${this.$store.state.domain}/api/fr/cards/${cardNumber}/check`).then(response => {
                    if (response.status === 200) {
                        this.updateStoreForAppointmentFromApiResponse(response);
                        this.isExistingAppointment = true;
                        this.confirmationToken = this.$store.state.confirmationToken
                        localStorage.sivecNumber = cardNumber;
                    }
                });
                // Load edit/delete section
                this.isExistingAppointment = true;
                this.confirmationToken = params.confirmationToken;
                this.$store.commit('changeData', {
                    type: 'sivecNumber',
                    value: cardNumber,
                });
                this.$store.commit('changeData', {
                    type: 'confirmationToken',
                    value: confirmationToken,
                });
            }
            const v = this;
            setTimeout(function () {
                v.number = v.$store.state.sivecNumber;
            }, 50);
        },
        methods: {
            hasNoAppointmentId() {
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              return !this.$store.state.appointmentId && urlParams.get('cardNumber') && urlParams.get('confirmationToken')
            },
            validateCard() {
                let formatedNumber = this.number.replace(/-|\s/g, '');
                axios
                    .get(`${this.$store.state.domain}/api/fr/cards/${formatedNumber}/check`)
                    .then(response => {
                        if (response.status === 204) {
                            this.$store.commit('changeData', {
                                type: 'sivecNumber',
                                value: formatedNumber,
                            });
                            this.$store.commit('changeData', {
                                type: 'sivecNumberConfirmation',
                                value: true,
                            });
                            this.numberValidated = true;

                            //scroll to section after validated card
                            setTimeout(function () {
                                cancelScroll = VueScrollTo.scrollTo('#vehicule', 1000, {
                                    onCancel: function () {
                                        cancelScroll();
                                    },
                                });
                            }, 500);

                            // save sivec number to local storage
                            localStorage.sivecNumber = formatedNumber;
                        } else if (response.status === 200) {
                            this.updateStoreForAppointmentFromApiResponse(response);
                            this.isExistingAppointment = true;
                            localStorage.sivecNumber = formatedNumber;
                        }
                    })
                    .catch(error => {
                        this.valid = false;
                        if (error) {
                          if (error.response?.data?.status || error.response?.data?.message) {
                            this.$store.commit('addErrorMessage',  error.response?.data?.message || error.response?.data?.status);
                          } else if (error.response?.data?.extraData?.message) {
                            this.$store.commit('addErrorMessage', error.response.data.extraData.message);
                          } else {
                            this.$store.commit('addErrorMessage', 'Error')
                          }
                        }
                    });
            },
            checkSubmission(ev) {
                if (ev.key === 'Enter') {
                    ev.preventDefault();
                    this.validateCard();
                }
            },
            reset() {
                this.number = '';
                localStorage.removeItem('sivecNumber');
                this.numberValidated = false;
                this.isExistingAppointment = false;
                this.$store.commit('changeData', {
                    type: 'sivecNumberConfirmation',
                    value: false,
                });
                this.valid = true;
                this.$store.commit('changeData', {
                    type: 'sivecNumber',
                    value: '',
                });
                this.$store.commit('hideSection', 'summarySection');
            },
            appointmentSummary() {
                // undo isDeleteScreen
                this.isDeleteScreen = false;
            },
            editAppointment () {
                // Store confirmation token for further api call
                this.$store.commit('changeData', {
                    type: 'confirmationToken',
                    value: this.confirmationToken,
                });
                // Check the confirmation code
                axios.get(`${this.$store.state.domain}/api/fr/appointments/${this.$store.state.appointmentId}/${this.confirmationToken}`)
                    .then(() => {
                      this.invalidConfirmationCode = false
                        this.isConfirmationCodeChecked = true;
                        // If yes, show the entire page prefilled
                        this.numberValidated = true;
                        this.$store.commit('changeData', {
                            type: 'sivecNumberConfirmation',
                            value: true,
                        });
                        this.$store.commit('changeData', {
                            type: 'dateSelection',
                            value: true,
                        });
                        //scroll to section after validated card
                        setTimeout(function () {
                            cancelScroll = VueScrollTo.scrollTo('#vehicule', 1000, {
                                onCancel: function () {
                                    cancelScroll();
                                },
                            });
                        }, 500);
                    })
                    .catch(error => {
                      console.log(error)
                      this.showInvalidConfirmationCode()
                    });
            },
            deleteAppointment() {
                // Check the confirmation code
                axios.get(`${this.$store.state.domain}/api/fr/appointments/${this.$store.state.appointmentId}/${this.confirmationToken}`)
                    .then(() => {
                      this.invalidConfirmationCode = false
                        this.isConfirmationCodeChecked = true;
                        if (this.isDeleteScreen) {
                            // If yes, do the delete api call
                            axios.patch(`${this.$store.state.domain}/api/fr/appointments/${this.$store.state.appointmentId}/${this.confirmationToken}`)
                                .then(() => {
                                  window.location = window.location.pathname
                                });
                        } else {
                            // If not, Check the confirmation code then show the delete confirmation screen
                            this.isDeleteScreen = true;
                        }
                    })
                  .catch(error => {
                    console.log(error)
                    this.showInvalidConfirmationCode()
                  });
            },
            showInvalidConfirmationCode() {
              this.invalidConfirmationCode = true
            },
            updateStoreForAppointmentFromApiResponse(response) {
                this.$store.commit('changeData', {
                    type: 'appointmentId',
                    value: response.data.id,
                });
                this.$store.commit('changeData', {
                    type: 'sivecNumber',
                    value: response.data.card.cardNumber,
                });
                this.$store.commit('changeData', {
                    type: 'plateNumber',
                    value: response.data.plateNumber,
                });
                this.$store.commit('changeData', {
                    type: 'vehicleType',
                    value: response.data.vehicleType,
                });
                this.$store.commit('changeData', {
                    type: 'vehicleTypeId',
                    value: response.data.vehicleType.id,
                });
                this.$store.commit('changeData', {
                    type: 'appointmentAt',
                    value: response.data.appointmentAt,
                });
                this.$store.commit('changeData', {
                    type: 'selectedTime',
                    value: moment(response.data.appointmentAt).format('HH:mm'),
                });
                this.$store.commit('changeData', {
                    type: 'selectedDateId',
                    value: moment(response.data.appointmentAt).format('YYYY-MM-DD'),
                });
                this.$store.commit('changeData', {
                    type: 'selectedDate',
                    value: moment(response.data.appointmentAt).locale('fr').format('dddd D MMMM YYYY'),
                });
                let wasteTypes = [];
                response.data.wasteTypes.forEach(element => {
                    wasteTypes.push(element.id)
                })
                this.$store.commit('changeData', {
                    type: 'materialSelection',
                    value: wasteTypes,
                });
                this.$store.commit('changeData', {
                    type: 'phone',
                    value: response.data.phoneNumber,
                });
                this.$store.commit('changeData', {
                    type: 'email',
                    value: response.data.email,
                });

                this.$store.commit('changeData', {
                    type: 'isExistingAppointment',
                    value: true,
                });
            }
        }
    };

</script>

<style scoped lang="scss">
    @import "src/assets/scss/button";

    .container {
        margin-bottom: 100px;
    }

    @media only screen and (max-width: 500px) {
        .container {
            margin-bottom: 50px;
        }
    }

    .box {
        background-color: var(--green--dark);
        border-radius: 4px;
        display: flex;
        align-items: center;
        min-height: 370px;
        position: relative;
    }

    .box::before {
        content: "";
        background-color: var(--green--light);
        position: absolute;
        top: 50%;
        right: -50vw;
        bottom: -500px;
        left: -50vw;
        z-index: -1;
    }

    .box__inner {
        margin: 0 auto;
        max-width: 690px;
        padding: var(--xlarge) var(--xmedium);
        color: white;
        width: 100%;
    }

    @media only screen and (max-width: 500px) {
        .box__inner {
            padding: var(--xlarge) var(--medium);
        }
    }

    h1 {
        color: var(--green--dark);
        font-size: 64px;
        text-align: center;
    }

    @media only screen and (max-width: 500px) {
        h1 {
            font-size: 38px;
        }
    }

    h2 {
        color: white;
        margin-top: 0;
        text-align: center;
    }

    @media only screen and (max-width: 500px) {
        h2 {
            font-size: 26px;
        }
    }

    label {
        color: white;
        display: block;
        margin-bottom: 5px;
    }

    .card-verification__input {
      border: none;
      border-radius: 4px;
      margin-bottom: var(--large);
      padding: var(--medium);
      width: 100%;
    }

    .card-verification__input-tooltip .card-verification__input {
      margin-right: 10px;
      margin-bottom: 0;
    }

    @media only screen and (max-width: 500px) {
      .card-verification__input {
            text-align: center;
        }
    }

    .card-verification__input::placeholder {
        color: var(--grey);
        opacity: 0.6;
    }

    .confirmation p,
    .invalid .number {
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 36px;
    }

    @media only screen and (max-width: 500px) {
        .confirmation p,
        .invalid .number {
            font-size: 24px;
        }
    }

    .confirmation img,
    .invalid img {
        height: 50px;
        margin-left: 15px;
    }

    .button--cancel__container {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .invalid p {
        color: white;
        text-align: center;
    }

    .invalid p a {
        color: var(--green--light);
        text-decoration: underline;
    }

    .invalid-confirmation-code-message {
      display: flex;
      align-items: center;
      color: var(--orange);
      background-color: #E5F2DA;
      border-radius: 4px;
      padding: 6px 15px;
      margin-top: -35px;
    }

    .invalid-confirmation-code-message img {
      margin-right: 10px;
    }

    .card-verification__number {
      background-color: #396763;
      border-radius: 4px;
      color: white;
      padding: var(--medium);
      margin-bottom: var(--large);
    }

    @media only screen and (max-width: 500px) {
      .card-verification__number {
        text-align: center;
      }
    }

    .actions {
      padding-top: 40px;
      margin: 0 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
    }

    .actions::before {
      content: '';
      border-top: 1px solid var(--green--light);
      position: absolute;
      top: 0;
      right: -100px;
      left: -100px;
    }

    @media only screen and (max-width: 900px) {
      .actions::before {
        right: 0;
        left: 0;
      }
    }

    @media only screen and (max-width: 750px) {
      .actions {
        display: grid;
        grid-template-rows: 1fr 1fr;
        justify-content: center;
        gap: 15px;
        margin: 40px 0 0;
      }
    }

    .box__clock-title {
      position: relative;
      text-align: left;
    }

    @media only screen and (max-width: 900px) {
      .box__clock-title {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    .card-verification__input-tooltip {
      position: relative;
      margin-bottom: var(--large);
    }

    .card-verification__input-tooltip__tooltip {
      position: absolute;
      right: -40px;
      top: 13px;
    }

    @media only screen and (max-width: 1000px) {
      .card-verification__input-tooltip {
        display: flex;
        align-items: center;
      }

      .card-verification__input-tooltip__tooltip {
        position: relative;
        right: unset;
        top: unset;
      }
    }
</style>
